import {
  styled,
  spacing,
  css,
  Text,
  mq,
  zIndex,
  ZIndexLevel,
} from '@thg-commerce/enterprise-theme'
import { Button, Image, SafeHtml } from '@thg-commerce/gravity-elements'
import { GridItem } from '@thg-commerce/gravity-system'

export const SwatchSelectorTitle = styled.h3`
  ${Text('medium1', 'alternate')};
  margin-top: ${spacing(3)};
`

export const SwatchSelectorContent = styled(SafeHtml)`
  ${Text('bodyText', 'default')};
  margin-top: ${spacing(1)};
`

export const ImageContainer = styled.div`
  width: 100%;
`

export const LogoImageContainer = styled.div`
  margin: 0 auto -${spacing(3.25)};
  width: fit-content;
  position: relative;
  ${zIndex(ZIndexLevel.Low)}
`

export const StyledLogo = styled(Image)`
  max-width: 150px;
  height: 44px;
`

// TODO CSBOM-363 to make border styling fix generic and not site specific

export const SwatchSelectorThumbnail = styled(Image)<{ active?: boolean }>`
  width: 44px;
  height: 44px;
  margin-top: ${spacing(1)};
  margin-right: ${spacing(1)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-right: ${spacing(2)};
  }
  img {
    margin-top: 0;
    border: 2px solid ${(props) => props.theme.colors.palette.greys.white};
  }

  &:hover {
    cursor: pointer;
  }
  ${(props) =>
    props.active &&
    css`
      img {
        border-color: ${props.theme.colors.palette.brand.base};
      }
    `}
`

export const CountThumbnail = styled.a`
  ${Text('bodyText', 'default')};
  width: 44px;
  height: 44px;
  margin-top: ${spacing(1)};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  text-align: center;
  line-height: 2.5;
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  background-color: ${(props) => props.theme.colors.palette.greys.white};
  &:hover {
    color: ${(props) => props.theme.colors.palette.brand.base};
    text-decoration: underline;
    cursor: pointer;
  }
  &:focus {
    border: solid 1px ${(props) => props.theme.colors.palette.brand.base};
    text-decoration: underline;
  }
`

export const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
`

export const SwatchSelectorLink = styled.a`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${spacing(3)};
  margin-bottom: ${spacing(2)};
  color: ${(props) => props.theme.colors.palette.brand.base};
`

export const SwatchSelectorCTA = styled(Button)`
  width: fit-content;
  text-decoration: none;
  color: ${(props) => props.theme.colors.palette.brand.base};
  margin-top: ${spacing(2)};
`

export const Title = styled.h2`
  ${Text('large1', 'alternate')}
  text-align: center;
`

export const Subtitle = styled.p`
  ${Text('bodyText', 'default')}
  text-align: center;
  margin-top: ${spacing(1)};
`

export const SwatchSelectorGridItem = styled(GridItem)`
  margin-top: ${spacing(3)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-bottom: ${spacing(2)};
  }
`

export const StyledContent = styled.div`
  ${(props) => `border: solid 1px ${props.theme.colors.palette.greys.grey};`}
`

export const StyledContainer = styled.div`
  text-align: center;
  padding: 0 ${spacing(2)} ${spacing(3)};
`

export const CarouselControlsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: -${spacing(3.75)} ${spacing(1)} 0;
`
